export default __webpack_public_path__ + "static/media/payment.fefcab68.jpg";